/*
*
* File JS componente Highlight Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-highlight-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const highlightSlider = () =>
{
    let highlightSliderAll = document.querySelectorAll('.highlight-slider .swiper-container');
    if(!highlightSliderAll.length) return;
    
    highlightSliderAll.forEach(el => {
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.parentElement.querySelector('.swiper-pagination');

        let args =
        {
            slidesPerView: 1,
            spaceBetween: 25,
            speed: 600,
            /*
            autoplay: {
                delay: 5000,
            },
            */
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}

export default highlightSlider;

//--------------------------------------------------------------------//